import React, {useContext, useEffect, useState} from 'react';
import {AppCtx} from '../../../../AppCtx';
import {useNavigate, useLocation} from 'react-router-dom';
import {useSelectSong} from '../../../navigation/components/Navigation';
import './SearchComponent.css';
import {searchForSongs} from '../../services/songs-db';
import {useEventListener, useApplicationEvents} from '../../../../infrastructure/events/useBroadcastChannel';
import {SearchIndexRebuiltEvent, AddSongRequestedEvent} from '../../../../infrastructure/events/channels';
import {isWorkspaceReadOnly} from '../../../../shared/services/workspaceAccess';
import {getWorkspaceId} from '../../../../shared/services/dbUtils';
import {SearchResultCardComponent} from './SearchResultCardComponent';
import {SearchIndexStatusComponent, useSongSearchState} from './SearchIndexStatusComponent';

const SearchDashboardComponent = () => {
  const {setSearchResults, searchResults, selectedFile} = useContext(AppCtx);
  const navigate = useNavigate();
  const location = useLocation();
  const selectSong = useSelectSong();
  const [currentQuery, setCurrentQuery] = useState('');
  const state = useSongSearchState();
  const addSongRequested = useApplicationEvents(AddSongRequestedEvent);
  useEffect(() => {
    const query = new URLSearchParams(location.search).get('q');
    if (query) { setCurrentQuery(query); setSearchResults(searchForSongs(query)); }
    else if (location.pathname === '/app/search') navigate('/');
  }, [location.search, location.pathname, navigate, setSearchResults, state.revision]);
  useEventListener(SearchIndexRebuiltEvent, () => {
    const query = new URLSearchParams(location.search).get('q');
    if (query) setSearchResults(searchForSongs(query));
  }, [location.search, setSearchResults]);
  const open = song => { setSearchResults([]); selectSong(song.fileName, song.songNumber); };
  const add = selectedFile?.name && !isWorkspaceReadOnly(getWorkspaceId()) ? song => {
    addSongRequested.postMessage({sourceFileName: song.fileName, songNumber: song.songNumber, targetFileName: selectedFile.name});
  } : null;
  const results = searchResults || [];
  return <div className="search-dashboard">
    <header className="search-dashboard-header">
      <h1>Wyniki dla: „{currentQuery}”</h1>
      <p>{results.length ? `Znaleziono ${results.length} wyników` : state.status === 'ready' ? 'Nie znaleziono wyników' : 'Oczekiwanie na aktualny indeks'}</p>
      <SearchIndexStatusComponent state={state} />
    </header>
    <div className="search-results-list">{results.map(result => <SearchResultCardComponent key={result.id}
      result={result} query={currentQuery} onOpen={open} onAdd={add} stale={state.status !== 'ready'} />)}</div>
  </div>;
};
export default SearchDashboardComponent;
